import bannerPartenaire from '../assets/images/img-banner-partenaire.png';

const imgBannerPartenaire = () => {
  return (
    <div
        className="h-96 bg-cover bg-center"      
      style={{ backgroundImage: `url(${bannerPartenaire})` }}
    >           
    </div>
  );
};

export default imgBannerPartenaire;
